import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import styleClasses from '../css/mobile/MyPage.module.scss';

function MyPageMenu({ currentPage }) {
  //const { musicianID } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const currentLocation = location.pathname;

  const [released, setReleased]       = useState('');
  const [unreleased, setUnreleased]   = useState('');
  const [currentMenu, setCurrentMenu] = useState('');
  
  // 🔹 현재 경로가 "/my-page/musicard"면 기본적으로 열림
  const [isMusicardOpen, setIsMusicardOpen] = useState(currentLocation.startsWith('/my-page/musicard'));

  useEffect(() => {
    if (currentPage) {
      setCurrentMenu(currentPage);
      if (['position-skill', 'members', 'activity', 'contact'].includes(currentPage)) {
        setIsMusicardOpen(true);
      } else {
        setIsMusicardOpen(false);
      }
    } else {
      let locationArray = currentLocation.split('/');
      
      if (locationArray.length > 4) {
        if (locationArray[2] === 'archive') {
          if (locationArray[3] === 'released') {
            setReleased(styleClasses.active);
            setUnreleased('');
            setIsMusicardOpen(true);
          } else if (locationArray[3] === 'unreleased') {
            setReleased('');
            setUnreleased(styleClasses.active);
            setIsMusicardOpen(true);
          }
        }
      } else if (locationArray.length === 2) {
        setCurrentMenu(locationArray[1]);
      } else if (locationArray.length === 3) {
        setCurrentMenu(locationArray[2]);
      }
    }
  }, [currentLocation, currentPage]);

  // 🔹 My Musicard 클릭 시 토글 + 페이지 이동
  const handleMusicardClick = () => {
    setIsMusicardOpen(!isMusicardOpen); // 🔹 토글 상태 변경
    navigate('/my-page/musicard'); // 🔹 /my-page/musicard 로 이동
  };

  // 🔹 My Account 클릭 시 `/my-page`로 이동
  // const handleAccountClick = () => {
  //   navigate('/my-page');
  // };

  return (
    <div className={styleClasses.innerContent}>
      <ul className={styleClasses.menu}>
        {/* 🔹 My Account (항상 보임) */}
        <li>
          <Link to='/my-page' className={ currentMenu === 'my-page' ? styleClasses.active : undefined }>
            My Page
          </Link>
        </li>

        {/* 🔹 My Musicard (클릭하면 토글 & 페이지 이동) */}
        <li>
          <button type='button' className={ currentMenu === 'musicard' ? styleClasses.active : undefined } onClick={handleMusicardClick}>
            My Musicard
            <div className="commonIcon mobile">
              <i className={`${isMusicardOpen ? 'upBlack' : 'downBlack'} w24`}></i>
            </div>
          </button>
        </li>

        {/* 🔹 My Musicard가 열려있을 때만 보이는 메뉴들 */}
        {isMusicardOpen && (
          <>
            <li>
              <button type='button'>Archive</button>
              <ul className="submenu">
                <li>
                  <Link to={`/my-page/archive/released/`} className={released}>
                    Released Albums
                  </Link>
                </li>
                <li>
                  <Link to={`/my-page/archive/unreleased/`} className={unreleased}>
                    Unreleased
                  </Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to={`/my-page/activity/`} className={ currentMenu === 'activity' ? styleClasses.active : undefined }>
                Activity
              </Link>
            </li>
            <li>
              <Link to={`/my-page/position-skill/`} className={ currentMenu === 'position-skill' ? styleClasses.active : undefined }>
                Position & Skill
              </Link>
            </li>
            <li>
              <Link to={`/my-page/members/`} className={ currentMenu === 'members' ? styleClasses.active : undefined }>
                Members
              </Link>
            </li>
            <li>
              <Link to={`/my-page/contact/`} className={ currentMenu === 'contact' ? styleClasses.active : undefined }>
                Contact
              </Link>
            </li>
          </>
        )}
      </ul>
    </div>
  );
}

export default MyPageMenu;